import React, { useState } from 'react';

import { useNavigate } from 'react-router-dom';
import { useMutation } from '@tanstack/react-query';

import FormContainer from '../../../FormContainer';

import useLenderForm from '../../../../../forms/lender/lender';
import LenderService from '../../../../../services/LenderService';
import { useUiContext } from '../../../../../context/UiContext';

export default function Lender({ isVisible, lender, isEdit, readOnly }) {
  const [id] = useState(Math.random());

  const navigate = useNavigate();

  const { showToast } = useUiContext();

  const { mutate: createLender, isPending: isLenderCreating } = useMutation({
    mutationFn: LenderService.createLender,
    onSuccess: (data) => {
      if (!isEdit) {
        navigate(`/lenders/${data.id}?tab=Users`, { replace: true });
      } else {
        navigate(`/lenders/${data.id}`, { replace: true });
      }
      showToast({
        text: 'Lender created',
        type: 'success',
      });
    },
    onError: (error) => {
      console.log(error);
      showToast({
        text: 'Something went wrong',
        type: 'error',
      });
    },
  });

  const { mutate: updateLender, isPending: isLenderUpdating } = useMutation({
    mutationFn: (values) =>
      LenderService.updateLender({
        formValues: values,
        lenderId: lender.id,
      }),
    onSuccess: () => {
      console.log('updated');
      showToast({
        text: 'Lender updated',
        type: 'success',
      });
    },
    onError: (error) => {
      console.log(error);
    },
  });

  const lenderForm = useLenderForm(
    isEdit ? updateLender : createLender,
    lender,
    id
  );

  return (
    <div className="p-7 col-span-full sm:col-span-6 xl:col-span-4 bg-white dark:bg-slate-800 shadow-lg rounded-sm border border-slate-200 dark:border-slate-700 mb-10">
      <FormContainer
        readOnly={readOnly}
        form={lenderForm}
        isVisible={isVisible}
        noBillComId={readOnly}
        isSubmitting={isLenderCreating || isLenderUpdating}
      />
    </div>
  );
}
